
export const required = [{ required: true, message: "Dato requerido." }];
export const txtTexto = /^[a-zA-Z-äëïöüÄËÏÖÜáéíóúÁÉÍÓÚÑñ0-9,:¡!¿?()*_";#'/\s.]+$/i;